import { Fragment, useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useNavigate } from "react-router-dom";

// Importamos las constantes necesarias de Parametrizaciones.js
import { API_URL, BASE_URL } from '../Parametrizaciones.js';

function AdminTopImages() {

  const [file, setFile] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [listUpdate, setListUpdate] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 1. Verificación de Autenticación
  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      setIsAuthenticated(true);
    } else {
      navigate('/controllers/Masterinc');
    }
  }, [navigate]);

  // 2. Obtención de la lista de imágenes
  useEffect(() => {
    Modal.setAppElement('body');

    fetch(`${API_URL}?action=obtenerImagenesTop`)
      .then(res => {
        if (!res.ok) throw new Error("Error en la respuesta del servidor");
        return res.json();
      })
      .then(res => setImageList(res || []))
      .catch(err => {
        console.error("Error al obtener imágenes:", err);
      });

    setListUpdate(false);
  }, [listUpdate]); // Se vuelve a ejecutar cada vez que listUpdate pasa a true

  const selectedHandler = e => {
    setFile(e.target.files[0]);
  };

  // 3. Subir Imagen
  const sendHandler = async () => {
    if (!file) {
      alert('Debes seleccionar un archivo primero');
      return;
    }

    const formdata = new FormData();
    formdata.append('image', file);

    try {
      const res = await fetch(`${API_URL}?action=subirImagenTop`, {
        method: 'POST',
        body: formdata
      });

      const result = await res.text();
      console.log('Respuesta servidor:', result);

      // Disparamos la actualización de la lista de imágenes
      setListUpdate(true);

      // Limpiamos el input file
      const fileInput = document.getElementById('fileinput');
      if (fileInput) fileInput.value = null;
      setFile(null);

    } catch (err) {
      console.error("Error al subir imagen:", err);
      alert("Ocurrió un error al subir la imagen.");
    }
  };

  const modalHandler = (isOpen, image) => {
    setModalIsOpen(isOpen);
    setCurrentImage(image);
  };

  // 4. Eliminar Imagen
  const deletelHandler = async () => {
    if (!currentImage) return;

    // Si tu imagen viene con el formato "ID-nombre.jpg" o enviabas directamente el identificador/nombre
    let imageId = currentImage.includes('-') ? parseInt(currentImage.split('-')[0]) : currentImage;

    try {
      const res = await fetch(`${API_URL}?action=eliminarImagenTop`, {
        method: 'POST', // Usamos POST para mayor compatibilidad con JSON en PHP
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: imageId, nombreImagen: currentImage })
      });

      const result = await res.text();
      console.log('Imagen eliminada:', result);

      setModalIsOpen(false);
      setCurrentImage(null);

      // Disparamos la actualización de la lista
      setListUpdate(true);

    } catch (err) {
      console.error("Error al eliminar imagen:", err);
      alert("Error al eliminar la imagen.");
    }
  };

  if (!isAuthenticated) return null;

  return (
    <Fragment>

      <div class="aa-title">
        <div class="container">
          <br />
          <a href='/controllers/masterinc'>
            <svg width="50" height="50" fill="currentColor" class="bi bi-house-fill" viewBox="0 0 16 16" style={{ color: '#59abe3' }}>
              <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
              <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
            </svg>
          </a>
          <h2>Administrar Top 6</h2>
          <span></span>
        </div>
        <br />

        <div class="container">
          <div className="container mt-5">
            <div className="card p-3">
              <div className="row">
                <div className="col-10">
                  <input id="fileinput" onChange={selectedHandler} className="form-control" type="file" />
                </div>
                <div className="col-2">
                  <button onClick={sendHandler} type="button" className="btn btn-primary col-12">Cargar Imagenes</button>
                </div>
              </div>
            </div>
          </div>

          <div className="container mt-3" style={{ display: "flex", flexWrap: "wrap" }}>
            {imageList.map(image => (
              <div key={image} className="card m-2">
                <img src={`${BASE_URL}/${image}`} alt="..." className="card-img-top" style={{ height: "200px", width: "300px" }} />
                <div className="card-body">
                  <button className="btn btn-secondary" onClick={() => modalHandler(true, image)}>Mostrar Imagen</button>
                </div>
              </div>
            ))}
          </div>

          <Modal style={{ content: { right: "25%", left: "25%", height: "850px", width: "1000px" } }} isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false, null)}>
            <div className='card'>
              <img src={`${BASE_URL}/${currentImage}`} alt="..." />
              <div className="card-body">
                <button onClick={() => deletelHandler()} className="btn btn-danger">Eliminar</button>
              </div>
            </div>
          </Modal>
        </div>
        <br />
      </div>

    </Fragment>
  )
}

export default AdminTopImages;